import { render, staticRenderFns } from "./SimilarOpportunities.vue?vue&type=template&id=6d3c7d9c&scoped=true&"
import script from "./SimilarOpportunities.vue?vue&type=script&lang=ts&"
export * from "./SimilarOpportunities.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d3c7d9c",
  null
  
)

export default component.exports